import request from '@/utils/request'

export function getBannerItemList(data) {
    return request({
        url: '/backend/banner/getBannerItemList',
        method: 'post',
        data: data
    })
}
export function getBannerTargetList(data) {
    return request({
        url: '/backend/banner/getBannerTargetList',
        method: 'post',
        data: data
    })
}
export function getZbBannerTargetList(data) {
    return request({
        url: '/backend/banner/getZbBannerTargetList',
        method: 'post',
        data: data
    })
}
export function getList(data) {
    return request({
        url: '/backend/banner/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/banner/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/banner/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/banner/delete',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/banner/updateStatus',
        method: 'post',
        data: data
    })
}
export function updateSort(data) {
    return request({
        url: '/backend/banner/updateSort',
        method: 'post',
        data: data
    })
}